var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.63,56.22l-9.13-9.13c-1.57-1.57-1.47-4.17.28-5.62,1.53-1.26,3.8-1.03,5.2.37l5.22,5.22v-21.35c0-2.1,1.7-3.79,3.8-3.79s3.79,1.7,3.79,3.79v21.35s5.33-5.33,5.33-5.33c1.57-1.57,4.17-1.48,5.62.28,1.26,1.53,1.03,3.8-.37,5.21l-9.02,9.02c-2.96,2.96-7.77,2.96-10.74,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.28,64.79v1.91c0,2.1-1.7,3.8-3.8,3.8h-30.96c-2.1,0-3.8-1.7-3.8-3.8v-1.91c0-2.1-1.7-3.8-3.8-3.8h0c-2.1,0-3.8,1.7-3.8,3.8v1.91c0,6.29,5.1,11.39,11.39,11.39h30.96c6.29,0,11.39-5.1,11.39-11.39v-1.91c0-2.1-1.7-3.8-3.8-3.8h0c-2.1,0-3.8,1.7-3.8,3.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeDownload);
export default __webpack_public_path__ + "static/media/acae_download.a1adde08.svg";
export { ForwardRef as ReactComponent };